import Alpine from "alpinejs";
import { gsap } from "gsap";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const navigationSetup = () => {
    Alpine.store('navSetup', {
        isOpen: false,
        currentSidebarTab: null,
        isSettingsPanelOpen: false,
        isSubHeaderOpen: false,
        hasScrolled: false,
        hideLogo: false,
        disableHideLogo: false,
        isLight: Alpine.$persist(true),
        scroller: null,
        scrollSmooth () {
            window.scroller = ScrollSmoother.create({
                wrapper: "#smooth-wrapper",
                content: "#smooth-content",
                smooth: 2,
                effects: true,
                //smoothTouch: true,
                //normalizeScroll: true,
                onUpdate: (el) => {
                  Alpine.store('navSetup').scrolling(el);
                }
            });
           //window.scroller.kill()
        },
        scrolling (el) {
            this.hasScrolled = (el.scrollTop() > 50 ? true : false)
            if(!this.disableHideLogo) {
                if (this.hasScrolled) {
                    this.hideLogo = false;
                } else {
                    this.hideLogo = true;
                }
            }
        },
        toggle(){
            console.log(window.scroller);
            this.isOpen = !this.isOpen;
        }
    });
}

export default navigationSetup;